import React, { useEffect, useState } from 'react'
import {Avatar, Button, Input, Spinner} from '@nextui-org/react'
import {BsFileEarmarkExcel, BsSearch} from 'react-icons/bs'
import { GET, PATCH } from '../../../utils/requests';
import Paginations from '../../../components/Pagination';
import TrackInsertModal from '../../../components/TrackInsertModal';
import { track_uri } from '../../../utils/url';
import {TYPES} from '../../../utils/types'
import Ereen_Batlah from '../../../components/Modal/ereen_batlah';
import ExcelUrd from '../../../components/Excel';

const Ereen = () => {
  const [load, setLoad] = useState(false);
  const [data, setData] = useState([])
  const [pagination, setPagination] = useState({limit:6, all:'', totalPage:'',trackcode:''});
  const [page, setPage] = useState(1);

  const [pay, setPay] = useState('');
  const [phone, setPhone] = useState('');

  useEffect(() => {
    Get();
  }, [page]);

  const Get = async () => {
    setLoad(true)
    const b = await GET(track_uri+`?page=${page}&limit=${pagination.limit}&type=${TYPES.EREEN}&trackcode=${pagination.trackcode}`)
    setData(b.data.data);
    setPagination({...pagination, totalPage:b.data.totalPage, all:b.data.all, trackcode:''});
    setLoad(false);
  };

  const callback =()=> {
    Get();
  }

  const changePage = (page) => {
    setPage(page)
  };

  const handlePayDown = (event) => {
    if (event.key === 'Enter') {
      Get()
    }
  };

  return (
    <div>
      <div>

      <div className="flex flex-col mr-2 mt-2 font-Roboto">
          <div className="overflow-x-auto shadow-md sm:rounded-md">
            <div className="inline-block min-w-full align-middle">
              <div className="overflow-hidden ">
              <div className='bg-white p-4'>
                <div className='flex items-center justify-between'>
                  <h1 className='text-lg font-bold'>Эрээнд ирсэн ачааны мэдээлэл</h1>
                  <div className='flex gap-2'>
                    {/* <TrackInsertModal callback={callback}/> */}
                    <ExcelUrd callback={callback}/>
                  </div>
                </div>
                <div className='flex items-center gap-2'>
                  <input onKeyDown={handlePayDown} size='' className='border rounded-lg mt-2 focus:border-1 focus:border-blue-600 outline-none w-full p-2 bg-gray-100' value={pagination.trackcode} placeholder='Хайлт хийх' onChange={(e) => setPagination({...pagination, trackcode:e.target.value})}/>
                  {
                    load?
                    <Button className='mt-1 bg-gray-200 '><Spinner/></Button>
                    :
                    <Button onClick={Get} className='mt-1 bg-gray-200'>Хайх</Button>
                  }
                </div>
              </div>
                <table className="min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-700">
                  <thead className="bg-gray-50 dark:bg-gray-700">
                    <tr>
                      <th scope="col" className="p-4 text-sm font-normal">
                        No
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Ачааны код
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Утасны дугаар
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Огноо
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Төлбөр
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                      Төлөв
                      </th>
                    </tr>
                  </thead>
                  {
                    load?
                    <div className='flex items-center justify-center  p-4'>
                      <Spinner/>
                      <h1 className=''>Уншиж байна ...</h1>
                    </div>
                    :

                    <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                      {
                        data.map((item, index) => {
                          {/* const res = IMAGE_GET({key:item.profile_img}); */}

                          return(
                            <tr className="hover:bg-gray-100 dark:hover:bg-gray-700" key={index}>
                                <td className="p-2 w-4 text-center">
                                  {index+1}
                                </td>
                                <td className="py-2 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white flex flex-col">
                                  <label className=''>{item.trackcode}</label>
                                </td>
                                <td className="py-2 px-6 text-sm font-medium text-gray-500  dark:text-white text-overflow">
                                  <input onChange={(e)=> setPhone(e.target.value)} className='bg-gray-100 rounded-md p-2 w-full outline-none focus:border focus:border-blue-300' placeholder='Утасны дугаар оруулах'/>
                                </td>
                                <td className="py-2 px-6 text-sm font-medium text-gray-500  dark:text-white text-overflow">{item.date}</td>
                                <td className="py-2 px-6 text-sm font-medium whitespace-nowrap dark:text-white text-blue-700">
                                  <input onChange={(e)=> setPay(e.target.value)} className='bg-gray-100 rounded-md p-2 w-full outline-none focus:border focus:border-blue-300' placeholder='Төлбөр оруулах'/>
                                </td>
                                <td className="py-2 px-6 text-sm font-medium whitespace-nowrap dark:text-white text-blue-700">
                                  {/* {
                                    item.type === TYPES.EREEN &&
                                    <h1 className='text-xs text-center bg-blue-200 rounded-md p-2'>Эрээнд хүлээж авсан</h1>
                                  } */}
                                  {/* <Button size='sm'>Батлах</Button> */}
                                  <Ereen_Batlah callback={callback} pay={pay} id={item.id} phone={phone}/>
                                </td>
                                <td className="py-2 px-6 text-sm font-medium whitespace-nowrap dark:text-white text-blue-700">
                                  {
                                    item.type === TYPES.EREEN &&
                                    <h1 className='text-xs text-center bg-blue-200 rounded-md p-2'>Эрээнд хүлээж авсан</h1>
                                  }
                                </td>
                                
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  }
                </table>
                {
                  data.length === 0 &&
                  <div className='bg-white pt-8 text-center flex items-center justify-center flex-col'>
                    <img className='h-24' src='../../empty.gif'/>
                    <h1 className=''>Хоосон байна...</h1>
                  </div>
                }
               <Paginations initialPage={1} total={pagination.totalPage} alldata={pagination.all} onChange={changePage}/> 
               {/* onChange={changePage} */}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default Ereen


